import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../components/Button";
import { useAuth } from "../context/auth";

export default function WarningScreen() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!location.state) {
      navigate("/");
    }
  }, [location, navigate]);

  useEffect(() => {
    if (!currentUser) {
      navigate("/");
    }
  }, [currentUser]);

  return (
    <div className="warning">
      <h2 style={{ textAlign: "center" }}>WARNING!</h2>
      <p>
        KYEWB Hotel contains scary and horrible elements, and is not suitable
        for weaklings or babies.
      </p>
      <p>Closing the window or tab will start a new game.</p>
      <p style={{ marginBottom: "2rem" }}>Loading times may vary.</p>
      <Button onClick={() => navigate("/play", { state: location?.state })}>
        I understand
      </Button>
    </div>
  );
}
